import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaReact, FaNodeJs, } from 'react-icons/fa';
import { SiMongodb, SiTailwindcss, SiFirebase, SiReactrouter } from 'react-icons/si';

import img1 from '../../../images/project-details/daily-tasks/resized/1.png';
import img2 from '../../../images/project-details/daily-tasks/resized/2.png';
import img3 from '../../../images/project-details/daily-tasks/resized/3.png';
import img4 from '../../../images/project-details/daily-tasks/resized/4.png';
import img5 from '../../../images/project-details/daily-tasks/resized/5.png';
import img6 from '../../../images/project-details/daily-tasks/resized/6.png';
import img7 from '../../../images/project-details/daily-tasks/resized/7.png';
import img8 from '../../../images/project-details/daily-tasks/resized/8.png';


import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import useTitle from '../../../Hooks/useTitle';



const DailyTasksDetails = () => {

    useTitle('Project | Daily Tasks')


    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])

    return (
        <div>

            <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-4 md:mb-0 sm:mb-8 mb-8 mt-12'>
                <h1 className='uppercase text-center text-3xl sm:text-3xl md:text-4xl lg:text-4xl  animation lg:mt-0 md:mt-0 sm:mt-10 mt-10' data-aos='flip-right'>Daily <span className='text-rose-600 text-6xl'>Tasks</span></h1>
                {/* <div className=' ml-4'>
                    <div className="avatar lg:-mt-10 md:-mt-8 sm:-mt-24 -mt-24">
                        <div className="w-full sm:w-full md:w-56 lg:w-56 rounded-xl">
                            <img src={bikeAnimation2} alt='bike' />
                        </div>
                    </div>
                </div> */}
            </div>





            <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mb-24 animation mt-8' data-aos='zoom-in'>

                <div className="card   lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img2} alt="bike!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img1} alt="bike!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img3} alt="bike!" />
                </div>

                <div className="card lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img4} alt="bike!" />
                </div>

                <div className="card   lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img5} alt="bike!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img6} alt="bike!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img7} alt="bike!" />
                </div>

                <div className="card  lg:mx-0 md:mx-4 sm:mx-8 mx-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                    <img className='rounded-lg ' src={img8} alt="bike!" />
                </div>

            </div>

            <div>
                <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                </h1>

                <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                    <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                        <h1 className='text-justify text-lg' > ⚪ Daily Tasks is a website to manage daily tasks. One can add his daily tasks and can trace the tasks </h1> <br></br>

                        <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM, Firebase Authentication, amd Mongodb as the database. CRUD operation is done where needed. Besides tailwind css is used for the styling purpose. Some component libraries are also used for the design. </h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪  React hot toast and sweet alert is added to show the alerts for better user experience. For the server side  node.js and express.js has been used.  </h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ All the tasks data are sent to the mongodb server. there is no static data in this project.</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ User can keep track his/her completed tasks. Besides he/she can update the tasks. If a task is complete then the user can add comment or add note for that tasks. </h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ Multiple user can use this website and all the data are fetched by the user email. To add a task a user has to be logged in to the website first</h1> <br></br>

                        <h1 className='text-justify text-lg'> ⚪ Authentication is an important part of the website. There are some routes that are private routes. Which means a user can not visit the route if he is not logged in. For the Authentication purpose I have used the google's Firebase authentication system. I have added some authentication systems. Email-Password Login and Google Login </h1>

                    </div>


                    <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                        <h2 className='text-center text-3xl mt-4 mb-12 '>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div >

                            <a href='https://my-task-manager-f6e75.web.app/' target='blank' title='Live Site Demo'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-70 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Live Webssite</span>
                                            <FaEye className='text-3xl text-white'></FaEye>
                                        </div>
                                    </button>
                                </div>
                            </a>


                            <a href='https://github.com/Fahimsakib1/my-task-manager-client' target='blank' title='Client Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-right'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-blue-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Client Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>

                            
                            
                            
                            <a href='https://github.com/Fahimsakib1/my-task-manager-server' target='blank' title='Server Side Code'>
                                <div className='relative group mt-4 animation' data-aos='fade-left'>
                                    <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                    </div>
                                    <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                        <div className='flex space-x-3 justify-center items-center'>
                                            <span>Server Side Code</span>
                                            <BsGithub className='text-3xl text-white'></BsGithub>
                                        </div>
                                    </button>
                                </div>
                            </a>


                        </div>






                        <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                        <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaReact className='text-4xl mx-2 text-cyan-500'></FaReact>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <FaNodeJs className='text-4xl mx-2 text-green-500'></FaNodeJs>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Node JS</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiFirebase className='text-4xl mx-2 text-yellow-400'></SiFirebase>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Firebase</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiReactrouter className='text-4xl mx-2 text-red-600'></SiReactrouter>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>React Router</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiTailwindcss className='text-4xl mx-2 text-sky-500'></SiTailwindcss>
                                <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Tailwind</h1>
                            </div>

                            <div className='border-2 border-violet-700 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                <SiMongodb className='text-4xl mx-2 text-green-500'></SiMongodb>
                                <h1 className='text-white text-2xl py-2  mr-4'>MongoDB</h1>
                            </div>

                        </div>




                    </div>

                </div>




                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}


                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>




            </div>
        </div>
    );
};

export default DailyTasksDetails;